module.exports = __webpack_public_path__ + "img/sponsorB24.39f9b2a6.png";